import * as Yup from "yup";

const editFormValidation = Yup.object({
  item_name: Yup.string().required("Name is required"),
  headline: Yup.string()
    .required("Headline is required.")
    .max(85, "Headline must not exceed 85 characters."),
  images: Yup.array().min(1, "Image is required"),
  industry_ids: Yup.array().min(1, "Industry is required"),
  category_ids: Yup.array().min(1, "Category is required"),
  description: Yup.string().required("Description is required"),
  whats_included: Yup.string().required("whats included is required"),
  additional_info: Yup.string().optional().nullable(),
  cancellation_policy: Yup.string().required("Cancellation policy is required"),
  customer_input_field: Yup.string().optional().nullable(),
  max_guest: Yup.number()
    .typeError("Max number of guests must be a number")
    .nullable(),
  min_age: Yup.number().optional().nullable(),
  max_age: Yup.number().optional().nullable(),
  price: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Price type is required"),
  capacity: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Units is required"),
  comission: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Comission is required"),
  unit_name: Yup.string().required("Unit name is required"),
  price_description: Yup.string().optional().nullable(),
  offering: Yup.string().optional().nullable(),
  selling_points: Yup.string().optional().nullable(),
  duration_applicable: Yup.boolean(),
  duration_hours: Yup.number()
    .nullable()
    .when("duration_applicable", {
      is: true,
      then: (schema) => schema.required("Duration hours are required"),
      otherwise: (schema) => schema.nullable(),
    }),
  duration_minutes: Yup.number()
    .nullable()
    .when("duration_applicable", {
      is: true,
      then: (schema) => schema.required("Duration minutes are required"),
      otherwise: (schema) => schema.nullable(),
    }),
});

const editBasicFormValidation = Yup.object({
  industry_ids: Yup.array().min(1, "Industry is required"),
  category_ids: Yup.array().min(1, "Category is required"),
  commission: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Comission is required"),
});

export { editBasicFormValidation, editFormValidation };
